import React, { useState, useEffect, useContext, useCallback } from "react";
import { useQuery, useLazyQuery } from "@apollo/client";
import {
  ActionList,
  Button,
  Modal,
  Popover,
  RadioButton,
  ResourceList,
  InlineStack,
  BlockStack,
  Tabs,
  Text,
} from "@shopify/polaris";
import { Banner } from "lib/components";
import { baseHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { GET_EXPORT_FILTER, CHECK_ORDER_LINES } from "app/orders/apollo/queries";
import { useNavigate } from "react-router-dom";

const ExportOrder = (props) => {
  const { isOpenModal, setIsOpenModal, isVendor = false } = props;
  const { cms } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { loading: getExportFilterLoading, data: getExportFilter } = useQuery(GET_EXPORT_FILTER);
  const [banner, setBanner] = useState({
    isOpen: false,
    status: "",
    title: "",
    onDismiss: null,
  });

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([[], []]);
  const [vendorList, setVendorList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [fulfillmentStatus, setFulfillmentStatus] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [exportAll, setExportAll] = useState(true);
  const [isPrimaryActionLoading, setPrimaryAction] = useState(false);
  const [exportLink, setExportLink] = useState(false);
  const [exportPDFLink, setExportPDFLink] = useState(false);
  const [generate, setGenerate] = useState(false);
  const [isModalClickable, setIsModalClickable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState("");
  const [queryData, setQueryData] = useState({});
  const dataToFetch = {};
  const exportOrderUrl = "/export/order";
  const [
    getCheckOrderList,
    { loading: checkOrderLineLoading, data: checkOrderLineData },
  ] = useLazyQuery(CHECK_ORDER_LINES, { variables: { input: { ...queryData } } });

  useEffect(() => {
    let bannerData = false;
    if (!checkOrderLineLoading && checkOrderLineData && generate) {
      const responseData = baseHelper.getResponseData(checkOrderLineData, constant.gql.CHECK_ORDER_LINES);
      if (!responseData) {
        bannerData = {
          title:
            baseHelper.getResponseError(checkOrderLineData, constant.gql.CHECK_ORDER_LINES) ||
            cms("message.error.noOrder"),
          status: constant.CRITICAL,
        };
      }

      if (bannerData) {
        setPrimaryAction(false);
        setBanner({ ...bannerData, isOpen: true });
      } else {
        const csvDownloadRoute =
          (exportAll && `${exportOrderUrl}?status=accepted&bulkFulfill=true`) || `${exportOrderUrl}${params}`;
        // const pdfDownloadRoute = (exportAll && `${exportOrderUrl}/pdf`) || `${exportOrderUrl}/pdf${params}`;
        setPrimaryAction(false);
        setExportLink(csvDownloadRoute);
        // setExportPDFLink(pdfDownloadRoute);
      }
      setLoading(false);
    }
  }, [checkOrderLineLoading, checkOrderLineData, exportAll, params, cms]);

  useEffect(() => {
    if (!getExportFilterLoading || getExportFilter) {
      const exportFilterData = baseHelper.getResponseData(getExportFilter, constant.gql.GET_EXPORT_FILTER);
      if (!exportFilterData) {
        const bannerValue = {
          status: constant.CRITICAL,
          title: baseHelper.getResponseError(getExportFilter, constant.gql.GET_EXPORT_FILTER),
        };
        setBanner({ ...bannerValue, isOpen: true });
      }
      const { vendorFilter = [], statusFilter = [], fulfillmentStatuses = [], orderStatuses = [] } = exportFilterData;
      if (!(statusFilter && statusFilter.length)) {
        setIsModalClickable(false);
        return;
      }
      setStatusList(statusFilter);
      setFulfillmentStatus(fulfillmentStatuses);
      setOrderStatus(orderStatuses);
      setVendorList(vendorFilter);
    }
  }, [getExportFilter, getExportFilterLoading]);

  const exportOrder = {
    label: {
      resourceName: [
        { singular: cms("section.exportOrder.label.vendor"), plural: cms("section.exportOrder.label.vendors") },
        { singular: cms("section.exportOrder.label.status"), plural: cms("section.exportOrder.label.statuses") },
      ],
    },
    exportModalTabs: [
      {
        id: "vendors",
        content: cms("section.exportOrder.label.vendor"),
        panelID: "panel-vendors",
      },
      {
        id: "status",
        content: cms("section.exportOrder.label.status"),
        panelID: "panel-status",
      },
    ],
  };

  const onExport = () => {
    setLoading(true);
    setGenerate(true);
    setPrimaryAction(true);
    let bannerData = false;
    let vendor = [];
    const fulfillmentStatusNew = [];
    const orderStatusNew = ["accepted"];

    vendor = [...selectedOptions[0]];
    const fulfillmentString = fulfillmentStatusNew.join(",");
    const orderString = orderStatusNew.join(",");
    const vendorString = vendor.join(",");
    if (!(exportAll || vendorString || fulfillmentString || orderString)) {
      setLoading(false);
      bannerData = {
        title: cms("message.error.pleaseSelect"),
        status: constant.CRITICAL,
      };
      setPrimaryAction(false);
      setBanner({ ...bannerData, isOpen: true });
      return;
    }
    setParams(`?vendor=${vendorString}&status=accepted&bulkFulfill=true`);
    if (orderStatusNew.length > 0) {
      dataToFetch.status = orderStatusNew;
    }
    if (fulfillmentStatusNew.length > 0) {
      dataToFetch.fulfillmentStatus = fulfillmentStatusNew;
    }
    if (vendor.length > 0) {
      dataToFetch.vendor = vendor;
    }
    setQueryData(dataToFetch);
    getCheckOrderList();
    setExportLink(false);
    setExportPDFLink(false);
  };

  const toggleBanner = () => {
    setBanner({
      isOpen: false,
      status: "",
      title: "",
    });
  };

  const getResourceListTabs = () => {
    const exportModalTabs = baseHelper.cloneData(exportOrder.exportModalTabs);
    // const singularItem = cms("section.exportOrder.label.item");
    // const pluralItem = cms("section.exportOrder.label.items");
    // const changeIndex = 0;
    // selectedOptions.forEach((item, index) => {
    //   if (item.length > 0) {
    //     exportModalTabs[index + changeIndex].content += ` (${item.length} ${
    //       item.length === 1 ? singularItem : pluralItem
    //     } ${cms("section.exportOrder.label.Selected")})`;
    //   }
    // });
    return [exportModalTabs[0]];
  };
  const closeModal = () => {
    setSelectedTabIndex(0);
    setSelectedOptions([[], []]);
    setExportAll(true);
    setPrimaryAction(false);
    setExportLink(false);
    setExportPDFLink(false);
    setIsOpenModal(false);
    setLoading(false);
    toggleBanner();
    setGenerate(false);
  };

  const downloadCSV = () => {
    window.open(exportLink);
    closeModal();
  };

  const handleSelectionChange = (selectedItems) => {
    const prevSelectedOptions = [...selectedOptions];
    prevSelectedOptions[selectedTabIndex] = [...selectedItems];
    setSelectedOptions(prevSelectedOptions);
    setExportLink(false);
    setExportPDFLink(false);
    setLoading(false);
  };

  const handleTabChange = (selectedTabInde) => {
    setSelectedTabIndex(selectedTabInde);
    setExportLink(false);
    setExportPDFLink(false);
  };

  const items = [vendorList, statusList];
  const updateResourceName = [...exportOrder.label.resourceName];

  const promotedBulkActions = [
    {
      content: cms("section.exportOrder.label.generate"),
      onAction: () => onExport(true),
    },
  ];
  const [active, setActive] = useState(false);
  const [popoverActive, setPopoverActive] = useState(false);

  const handleChange = () => {
    setActive(!active);
    setPopoverActive(!popoverActive);
  };

  const activator = (
    <Button onClick={handleChange} disclosure>
      {cms("section.exportOrder.label.selectFormat")}
    </Button>
  );
  const togglePopoverActive = useCallback(() => setPopoverActive(!popoverActive), [popoverActive]);

  const handlePopover = () => {
    return (
      <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
        <ActionList
          items={[
            {
              content: cms("section.exportOrder.label.exportCSV"),
              onAction: () => {
                setLoading(false);
                downloadCSV();
              },
            },
          ]}
        />
      </Popover>
    );
  };

  const actions = () => (
    <InlineStack gap="100" align="center">
      {/* <Link onClick={() => navigate("/setting/order/export")}>
        {cms("section.exportOrder.label.customize")}
      </Link> */}
      <Button onClick={() => closeModal()}>{cms("section.exportOrder.label.cancel")}</Button>
      {exportLink ? (
        handlePopover()
      ) : (
        <Button variant="primary" onClick={() => onExport()} loading={loading}>
          {cms("section.exportOrder.label.generate")}
        </Button>
      )}
    </InlineStack>
  );
  return (
    <>
      <Modal
        open={isOpenModal}
        onClose={() => closeModal()}
        title={cms("section.exportOrder.label.exportOrder")}
        footer={actions()}
      >
        {banner.isOpen && (
          <Banner
            key="banner"
            onDismiss={toggleBanner}
            title={banner.title}
            status={banner.status}
            isOpen={banner.isOpen}
          />
        )}
        <Modal.Section>
          <BlockStack>
            <RadioButton
              label={cms("section.exportOrder.label.exportAll")}
              helpText={cms("section.exportOrder.label.exportAllText")}
              checked={exportAll}
              name="allOrders"
              onChange={() => {
                setGenerate(false);
                setBanner({ isOpen: false });
                setExportAll((prevState) => !prevState);
                setExportPDFLink(false);
                setExportLink(false);
              }}
            />
            {!isVendor && (
              <RadioButton
                label={cms("section.exportOrder.label.exportSelected")}
                helpText={cms("section.exportOrder.label.exportSelectedText")}
                name="selectedOrders"
                checked={!exportAll}
                onChange={() => {
                  setGenerate(false);
                  setExportAll((prevState) => !prevState);
                  setExportPDFLink(false);
                  setBanner({ isOpen: false });
                  setExportLink(false);
                }}
              />
            )}
          </BlockStack>
          {!exportAll && (
            <>
              <Tabs
                key="tabs"
                tabs={getResourceListTabs()}
                selected={selectedTabIndex}
                onSelect={handleTabChange}
                fitted
              >
                <ResourceList
                  key="resourceList"
                  resourceName={updateResourceName[selectedTabIndex]}
                  items={items[selectedTabIndex]}
                  renderItem={(item) => {
                    const { id, name, location } = item;
                    const replaceName = {
                      noShow: constant.NOSHOW,
                    };
                    const statusName = name.replace(/\b(?:noShow)\b/gi, (matched) => replaceName[matched]);
                    return (
                      <ResourceList.Item id={id} accessibilityLabel={`${cms("section.export.label.view")} ${id}`}>
                        <h3>
                          <Text as="span" fontWeight="semibold">
                            {baseHelper.ucFirst(statusName)}
                          </Text>
                        </h3>
                        <div>{location}</div>
                      </ResourceList.Item>
                    );
                  }}
                  selectedItems={selectedOptions[selectedTabIndex]}
                  onSelectionChange={handleSelectionChange}
                  selectable
                  promotedBulkActions={promotedBulkActions}
                  loading={getExportFilterLoading}
                />
              </Tabs>
            </>
          )}
        </Modal.Section>
      </Modal>
    </>
  );
};

export default ExportOrder;
